import React, { type ReactNode } from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { trackPixelEvent } from '../../utils/metaPixel';
type ButtonProps = {
  href: string;
  label: string;
  variant?: 'primary' | 'ghost' | 'light';
  size?: 'md' | 'lg';
  withIcon?: boolean;
  className?: string;
};

/** Todos los CTA son links reales: cambiá la URL en data/links.ts */
export function CtaLink({
  href,
  label,
  variant = 'primary',
  size = 'lg',
  withIcon = true,
  className = ''
}: ButtonProps) {
  const isExternal = href.startsWith('http');
  const base = 'inline-flex items-center justify-center gap-2 rounded-full font-semibold transition-colors duration-150 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#3b6bff]';
  const sizes = {
    md: 'px-5 py-3 text-sm',
    lg: 'px-6 py-3.5 text-base sm:px-8 sm:py-4 sm:text-lg'
  };
  const variants = {
    primary: 'bg-[#3b6bff] text-white hover:bg-[#2b57e0]',
    ghost: 'border border-white/25 text-white hover:border-white/50 hover:bg-white/5',
    light: 'bg-white text-[#08090b] hover:bg-white/85'
  };
  return <a href={href} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} onClick={() => {
    if (href.includes('wa.me')) {
      trackPixelEvent('Contact', {
        content_name: label
      });
    }
  }} className={`${base} ${sizes[size]} ${variants[variant]} ${className}`} data-id="element-126" data-mp="bjllsxdt4osw">
      {withIcon && <MessageCircleIcon className="h-5 w-5 shrink-0" strokeWidth={2.2} data-id="element-127" data-mp="u88s1j7pzk82" />}
      {label}
    </a>;
}
export function Section({
  id,
  children,
  className = ''
}: {
  id?: string;
  children: ReactNode;
  className?: string;
}) {
  return <section id={id} className={`scroll-mt-16 px-5 py-14 sm:px-8 sm:py-20 lg:px-12 lg:py-28 ${className}`} data-id="element-128" data-mp="30zztou5u9fmu">
      <div className="mx-auto w-full max-w-6xl" data-id="element-129" data-mp="35ykx12ge0ffi">{children}</div>
    </section>;
}
export function Kicker({
  children
}: {
  children: ReactNode;
}) {
  return <div className="flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.28em] text-[#7f9bff] sm:text-xs" data-id="element-130" data-mp="2y0hl6uqsa72w">
      <span className="h-px w-8 bg-[#3b6bff]" data-id="element-131" data-mp="37wb6p3mhdawt" />
      {children}
    </div>;
}
export function Heading({
  children,
  className = ''
}: {
  children: ReactNode;
  className?: string;
}) {
  return <h2 className={`font-display text-3xl font-bold leading-[1.08] sm:text-4xl lg:text-5xl ${className}`} data-id="element-132" data-mp="3gx0txixodsyx">
      {children}
    </h2>;
}
export function Lead({
  children,
  className = ''
}: {
  children: ReactNode;
  className?: string;
}) {
  return <p className={`text-base leading-relaxed sm:text-lg ${className}`} data-id="element-133" data-mp="3qp6q74uymwjx">
      {children}
    </p>;
}